import { useMutation } from 'react-query';
import { MutationConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapFileUploadCheckToApiDto = (data: IBillingUploadForm): IBillingUploadCheck => {
  return {
    month: +data.month,
    providerID: +data.providerID,
    year: +data.year
  }
}

const checkFileImport = ( {data} : {data: IBillingUploadForm}): Promise<ICheckFileImportResponse> => {
  const mapedData = mapFileUploadCheckToApiDto(data);
  return axiosDefaultApi.post(`/api/Billing/CheckImport`, mapedData);
};

type QueryFnType = typeof checkFileImport;

type UseCheckFileImportOptions = {
  data: IBillingUploadForm;
  config?: MutationConfig<QueryFnType>;
};

export const useCheckFileImport = ({ config }: UseCheckFileImportOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
      onError: (error: any) => {
        addNotification(`Υπήρξε κάποιο πρόβλημα στον Έλεγχο.`, 500);
        console.error('Couldnt check import', error);
        setIsNotificationVisible(true)
      },
      onSuccess: () => {},
      ...config,
      mutationFn: checkFileImport,
    })
}

type ICheckFileImportResponse = {
  hasBilling: boolean;
}